document.addEventListener('DOMContentLoaded', function () {

// ---- Countdown Timer ----
(function () {
  var hourElement = document.getElementById('cnt-h');
  var minuteElement = document.getElementById('cnt-m');
  var secondElement = document.getElementById('cnt-s');

  // Do not run the countdown on pages where its HTML does not exist.
  if (!hourElement || !minuteElement || !secondElement) {
    return;
  }

  var end = new Date();
  end.setHours(end.getHours() + 2);

  function tick() {
    var now = new Date();
    var diff = end - now;

    if (diff <= 0) {
      diff = 0;
    }

    var hours = Math.floor(diff / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);

    hourElement.textContent = String(hours).padStart(2, '0');
    minuteElement.textContent = String(minutes).padStart(2, '0');
    secondElement.textContent = String(seconds).padStart(2, '0');
  }

  tick();
  setInterval(tick, 1000);
})();

  // ---- Delivery Date ----
  function setDeliveryDate(elId){
    var el = document.getElementById(elId);
    if(!el) return;
    var d = new Date(); d.setDate(d.getDate()+3);
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var day = d.getDate();
    var suffix = day===1||day===21||day===31?'st':day===2||day===22?'nd':day===3||day===23?'rd':'th';
    el.textContent = months[d.getMonth()]+' '+day+suffix;
  }
  setDeliveryDate('delivery-date');
  setDeliveryDate('delivery-date2');

// ---- Product Swiper: main + thumbnails ----
var thumbsSwiper = null;

if (document.querySelector('.thumbs-swiper')) {
  thumbsSwiper = new Swiper('.thumbs-swiper', {
    slidesPerView: 5,
    spaceBetween: 6,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    navigation: {
      prevEl: '#thumb-prev',
      nextEl: '#thumb-next'
    }
  });
}

if (document.querySelector('.main-swiper')) {
  new Swiper('.main-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    thumbs: thumbsSwiper ? {
      swiper: thumbsSwiper
    } : undefined
  });
}

// ---- Desktop Video Testimonials ----
if (document.querySelector('#oo-vt-desk')) {
  new Swiper('#oo-vt-desk', {
    slidesPerView: 3,
    spaceBetween: 14,
    loop: true,
    navigation: {
      prevEl: '#oo-vt-prev',
      nextEl: '#oo-vt-next'
    }
  });
}

// ---- Mobile Video Testimonials ----
if (document.querySelector('#oo-vt-mob')) {
  new Swiper('#oo-vt-mob', {
    loop: true,
    speed: 500,
    grabCursor: true,
    slidesPerView: 1.25,
    spaceBetween: 14,
    centeredSlides: false,
    freeMode: false,
    touchStartPreventDefault: false,
    touchReleaseOnEdges: true,
    threshold: 5,
    touchRatio: 1,
    navigation: {
      prevEl: '#oo-vt-prev',
      nextEl: '#oo-vt-next'
    },
    breakpoints: {
      700: {
        slidesPerView: 3
      }
    }
  });
}

// ---- Compounds Swiper ----
if (document.querySelector('#compounds-mob')) {
  new Swiper('#compounds-mob', {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    speed: 500,
    grabCursor: true,
    navigation: {
      nextEl: '.comp-next',
      prevEl: '.comp-prev'
    }
  });
}

// ---- Review Cards Swiper ----
if (document.querySelector('.ts-review-swiper')) {
  new Swiper('.ts-review-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      prevEl: '#ts-prev',
      nextEl: '#ts-next'
    },
    pagination: {
      el: '.ts-pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      }
    }
  });
}

// ---- Reasons Swiper ----
if (document.querySelector('#reasons-swiper')) {
  new Swiper('#reasons-swiper', {
    slidesPerView: 1,
    spaceBetween: 12,
    loop: true,
    navigation: {
      prevEl: '#reasons-prev',
      nextEl: '#reasons-next'
    },
    pagination: {
      el: '.reasons-pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      }
    }
  });
}

// ---- VT Swiper ----
if (document.querySelector('#vt-swiper')) {
  new Swiper('#vt-swiper', {
    slidesPerView: 3,
    spaceBetween: 0,
    loop: true,
    navigation: {
      prevEl: '#vt-prev',
      nextEl: '#vt-next'
    },
    pagination: {
      el: '.vt-pagination',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 6
      }
    }
  });
}

  // ---- Video play buttons ----
  document.body.addEventListener('click', function(e){
    var btn = e.target.closest('.play-btn');
    if(!btn) return;
    var vw = btn.closest('.video-wrapper,.vw');
    var video = vw ? vw.querySelector('video') : null;
    if(!video) return;
    document.querySelectorAll('video').forEach(function(v){
      if(v !== video){ v.pause(); var pb = v.parentElement.querySelector('.play-btn'); if(pb) pb.style.opacity='1'; }
    });
    if(video.paused){ video.play(); btn.style.opacity='0'; }
    else { video.pause(); btn.style.opacity='1'; }
    video.addEventListener('pause', function(){ btn.style.opacity='1'; }, {once:true});
  });

  // ---- FAQ toggles ----
  document.querySelectorAll('.faq-question').forEach(function(btn){
    btn.addEventListener('click', function(){
      var ans = btn.nextElementSibling;
      var isOpen = ans.classList.contains('open');
      document.querySelectorAll('.faq-answer.open').forEach(function(a){ a.classList.remove('open'); a.previousElementSibling.querySelector('span').textContent='+'; });
      if(!isOpen){ ans.classList.add('open'); btn.querySelector('span').textContent='−'; }
      else{ btn.querySelector('span').textContent='+'; }
    });
  });

  // ---- Proven Benefits toggles ----
  document.querySelectorAll('.proven-toggle').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.proven-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.proven-item.open').forEach(function(i){ i.classList.remove('open'); });
      if(!isOpen) item.classList.add('open');
    });
  });

document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.proven-item');
  items.forEach(function (item) {
    var btn = item.querySelector('.proven-toggle');
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      items.forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
});
 
  // ---- Stats counter animation ----
  var statEls = document.querySelectorAll('.stat-pct');
  var statsObserver = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        var el = entry.target;
        if(el.classList.contains('counted')) return;
        el.classList.add('counted');
        var target = parseInt(el.dataset.target);
        var cur = 0;
        var step = function(){ cur++; el.textContent=cur+'%'; if(cur<target) setTimeout(step, 1000/target); };
        step();
        statsObserver.unobserve(el);
      }
    });
  }, {threshold:0.3});
  statEls.forEach(function(el){ statsObserver.observe(el); });

  // ---- Milestone animation ----
  var milestones = document.querySelectorAll('.milestone');
  var milObserver = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting) entry.target.classList.add('active');
      else entry.target.classList.remove('active');
    });
  }, {threshold:0.5, rootMargin:'0px 0px -200px 0px'});
  milestones.forEach(function(m){ milObserver.observe(m); });

  // ---- Read more reviews ----
  var readMoreBtn = document.getElementById('readMoreBtn');
  if(readMoreBtn){
    readMoreBtn.addEventListener('click', function(){
      var hidden = document.querySelectorAll('.ir-hidden');
      var expanded = readMoreBtn.classList.contains('expanded');
      hidden.forEach(function(el){ el.classList.toggle('show', !expanded); });
      readMoreBtn.textContent = expanded ? 'Read More Reviews' : 'Read Less Reviews';
      readMoreBtn.classList.toggle('expanded');
    });
  }

});

// Pure vanilla JS scroll animation — no jQuery dependency
function isScrolledIntoView(elem) {
  var rect = elem.getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  // Trigger 200px after the bottom of the element enters viewport
  return rect.bottom + 300 <= windowHeight;
}

function checkMilestones() {
  document.querySelectorAll('.milestone-item').forEach(function(item) {
    if (isScrolledIntoView(item)) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });
}

window.addEventListener('scroll', checkMilestones);
window.addEventListener('resize', checkMilestones);
// Run once on load in case items are already in view
checkMilestones();

(function(){
  // Gather every form that contains offer boxes
  var allForms = [];
  document.querySelectorAll('.offer-box').forEach(function(box){
    var form = box.closest('form');
    if (form && allForms.indexOf(form) === -1) {
      allForms.push(form);
    }
  });

  allForms.forEach(function(form){
    // Prevent double-init if the script ever runs twice
    if (form.dataset.offerInit === '1') return;
    form.dataset.offerInit = '1';

    // Scope to the form's parent container (price-rows, ggd-box, ATC, etc. are siblings here)
    var section = form.parentElement;
    if (!section || section === document.body) section = document;

    var offers       = form.querySelectorAll('.offer-box');
    var ggdRow       = section.querySelector('#ggdRow');
    var ggdItems     = ggdRow ? ggdRow.querySelectorAll('.ggd-item') : [];
    var priceRows    = section.querySelector('.price-rows');
    var atcPrice     = section.querySelector('#atcPrice');
    var atcCompare   = section.querySelector('#atcCompare');
    var savPriceTarget = section.querySelector('#savPriceTarget');
    var deliveryDate = section.querySelector('#deliveryDate');
    var faqButtons   = section.querySelectorAll('.faq-questions');
    var atcBtn       = section.querySelector('#atcBtn');

    function getActiveIndex(){
      var idx = -1;
      offers.forEach(function(o, i){ if (o.classList.contains('active')) idx = i; });
      return idx;
    }

    function syncGifts(){
      var unlocked = getActiveIndex() + 1; // 1, 2, or 3
      ggdItems.forEach(function(item){
        var unlockAt = parseInt(item.dataset.unlock, 10) || 1;
        item.classList.toggle('ggd-locked', unlockAt > unlocked);
      });
    }

    function syncPrices(){
      var active = offers[getActiveIndex()];
      if (!active) return;
      if (atcPrice) atcPrice.textContent = active.dataset.price;
      if (atcCompare) atcCompare.textContent = active.dataset.compare;
      if (savPriceTarget) savPriceTarget.textContent = active.dataset.save;
      if (priceRows) {
        var p = priceRows.querySelector('.price');
        var c = priceRows.querySelector('.compare-price');
        if (p) p.textContent = active.dataset.price;
        if (c) c.textContent = active.dataset.compare;
      }
    }

    offers.forEach(function(box){
      box.addEventListener('click', function(){
        offers.forEach(function(o){ o.classList.remove('active'); });
        box.classList.add('active');
        syncGifts();
        syncPrices();
      });
    });

    // Add to Cart -> redirect to the selected offer's Shopify cart/add URL (which then goes to checkout)
// Add selected product to Shopify cart first,
// give the gift app time to add gifts, then go to checkout.
if (atcBtn) {
  atcBtn.addEventListener('click', async function () {
    var active = offers[getActiveIndex()];

    if (!active || !active.dataset.url) {
      return;
    }

    // Prevent duplicate clicks.
    if (atcBtn.dataset.loading === '1') {
      return;
    }

    atcBtn.dataset.loading = '1';
    atcBtn.disabled = true;

    var originalHTML = atcBtn.innerHTML;

    atcBtn.innerHTML = '<span>Adding to cart...</span>';

    try {
      var selectedURL = new URL(active.dataset.url, window.location.origin);

      var variantId = selectedURL.searchParams.get('id');
      var sellingPlanId = selectedURL.searchParams.get('selling_plan');
      var quantity = parseInt(
        selectedURL.searchParams.get('quantity') || '1',
        10
      );

      if (!variantId) {
        throw new Error('No Shopify variant ID was found.');
      }

      var item = {
        id: Number(variantId),
        quantity: quantity
      };

      // Preserve subscription selling plan.
      if (sellingPlanId) {
        item.selling_plan = Number(sellingPlanId);
      }

      // Add the selected product without leaving the page.
      var response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [item]
          })
        }
      );

      var result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Unable to add this product to the cart.'
        );
      }

      /*
       * Notify Shopify theme and gift/cart apps that the cart changed.
       * Different apps listen for different event names.
       */
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            source: 'custom-product-form',
            product: result
          }
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            source: 'custom-product-form',
            product: result
          }
        })
      );

      document.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: result
        })
      );

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: result
        })
      );

      window.dispatchEvent(
        new CustomEvent('cart-updated', {
          detail: result
        })
      );
atcBtn.innerHTML = '<span>Redirecting to checkout...</span>';

// Briefly allow the gift app to process the cart update.
await new Promise(function (resolve) {
  setTimeout(resolve, 500);
});

// Redirect without making the additional cart.js request.
window.location.assign(
  window.Shopify.routes.root + 'checkout'
);

    } catch (error) {
      console.error('Add-to-cart error:', error);

      atcBtn.innerHTML = originalHTML;
      atcBtn.disabled = false;
      atcBtn.dataset.loading = '0';

      alert(
        error.message ||
        'We could not add the product. Please try again.'
      );
    }
  });
}

    // FAQ accordion (scoped to this section only)
    faqButtons.forEach(function(btn){
      btn.addEventListener('click', function(){
        var item = btn.closest('.faq-items');
        if (!item) return;
        var isOpen = item.classList.contains('active');

        // Close any open FAQ in this same section
        section.querySelectorAll('.faq-items.active').forEach(function(i){
          i.classList.remove('active');
          var span = i.querySelector('.faq-questions span');
          if (span) span.textContent = '+';
        });

        if (!isOpen) {
          item.classList.add('active');
          var span = btn.querySelector('span');
          if (span) span.textContent = '−';
        }
      });
    });

    // Delivery date (scoped to this section)
    if (deliveryDate){
      var d = new Date();
      d.setDate(d.getDate() + 3);
      var w = d.toLocaleString('default', {weekday:'short'});
      var m = d.toLocaleString('default', {month:'short'});
      deliveryDate.textContent = w + ', ' + m + ' ' + d.getDate();
    }

    syncGifts();
    syncPrices();
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector('.stats-section');
  if (!section) return;
 
  const parseStatTarget = (el) => {
    const raw = (el.getAttribute('data-target') || '').trim();
    const match = raw.match(/^(\D*)([\d.,\s]+)(.*)$/);
    if (!match) return null;
    const prefix = match[1] || '';
    const numericStr = match[2].replace(/[\s,]/g, '');
    const userSuffix = match[3] || '';
    const hasDecimal = numericStr.includes('.');
    const target = hasDecimal ? parseFloat(numericStr) : parseInt(numericStr, 10);
    if (isNaN(target)) return null;
    const hasCustomText = prefix.length > 0 || userSuffix.length > 0;
    const autoPct = el.getAttribute('data-hide-percent') === 'true' ? '' : '%';
    const suffix = hasCustomText ? userSuffix : autoPct;
    const decimals = hasDecimal ? (numericStr.split('.')[1] || '').length : 0;
    const formatValue = (val) => {
      if (decimals > 0) {
        return val.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      }
      return Math.round(val).toLocaleString('en-US');
    };
    return { prefix, target, suffix, formatValue };
  };
 
  section.querySelectorAll('.stat-pct').forEach(el => {
    const parsed = parseStatTarget(el);
    if (!parsed) return;
    el.textContent = parsed.prefix + parsed.formatValue(0) + parsed.suffix;
  });
 
  const animateStat = (el) => {
    const parsed = parseStatTarget(el);
    if (!parsed) return;
    const { prefix, target, suffix, formatValue } = parsed;
    const duration = target <= 100 ? 1000 : 1800;
    const startTime = performance.now();
    const easeOutQuad = (t) => 1 - (1 - t) * (1 - t);
    const update = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      el.textContent = prefix + formatValue(easeOutQuad(progress) * target) + suffix;
      if (progress < 1) requestAnimationFrame(update);
      else el.textContent = prefix + formatValue(target) + suffix;
    };
    requestAnimationFrame(update);
  };
 
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        section.querySelectorAll('.stat-pct').forEach(el => {
          if (!el.classList.contains('counted')) {
            el.classList.add('counted');
            animateStat(el);
          }
        });
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
 
  observer.observe(section);
});


/* =========================================================
   SUMMER SALE COUNTDOWN — START

   Behavior:
   - Starts at two hours for each visitor
   - Persists through page refreshes
   - Restarts at two hours when it reaches zero
   - Supports multiple copies of the countdown
========================================================= */

(() => {
  'use strict';

  const COUNTDOWN_SELECTOR =
    '[data-hh-summer-countdown]';

  const STORAGE_KEY =
    'hhSummerSaleCountdownEnd';

  const COUNTDOWN_DURATION =
    2 * 60 * 60 * 1000;

  function getCountdownEndTime() {
    const savedEndTime = Number(
      window.localStorage.getItem(STORAGE_KEY)
    );

    if (
      Number.isFinite(savedEndTime) &&
      savedEndTime > Date.now()
    ) {
      return savedEndTime;
    }

    const newEndTime =
      Date.now() + COUNTDOWN_DURATION;

    window.localStorage.setItem(
      STORAGE_KEY,
      String(newEndTime)
    );

    return newEndTime;
  }

  let countdownEndTime =
    getCountdownEndTime();

  function updateCountdowns() {
    let remainingTime =
      countdownEndTime - Date.now();

    if (remainingTime <= 0) {
      countdownEndTime =
        Date.now() + COUNTDOWN_DURATION;

      window.localStorage.setItem(
        STORAGE_KEY,
        String(countdownEndTime)
      );

      remainingTime = COUNTDOWN_DURATION;
    }

    const hours = Math.floor(
      remainingTime / (1000 * 60 * 60)
    );

    const minutes = Math.floor(
      (
        remainingTime %
        (1000 * 60 * 60)
      ) /
      (1000 * 60)
    );

    const seconds = Math.floor(
      (
        remainingTime %
        (1000 * 60)
      ) /
      1000
    );

    document
      .querySelectorAll(COUNTDOWN_SELECTOR)
      .forEach((countdown) => {
        const hoursElement =
          countdown.querySelector(
            '[data-hh-sale-hours]'
          );

        const minutesElement =
          countdown.querySelector(
            '[data-hh-sale-minutes]'
          );

        const secondsElement =
          countdown.querySelector(
            '[data-hh-sale-seconds]'
          );

        if (
          !hoursElement ||
          !minutesElement ||
          !secondsElement
        ) {
          return;
        }

        hoursElement.textContent =
          String(hours).padStart(2, '0');

        minutesElement.textContent =
          String(minutes).padStart(2, '0');

        secondsElement.textContent =
          String(seconds).padStart(2, '0');
      });
  }

  updateCountdowns();

  window.setInterval(
    updateCountdowns,
    1000
  );
})();

/* =========================================================
   SUMMER SALE COUNTDOWN — END
========================================================= */